/**
 * Kwoty żyją jako łańcuchy znaków przez całą drogę: baza trzyma numeric,
 * API oddaje tekst, panel oddaje tekst z powrotem. Liczba zmiennoprzecinkowa
 * w JavaScripcie nie potrafi zapisać 0,1 dokładnie, a cały model opiera się
 * na porównaniach co do grosza.
 */

/** '1 200,50' (Excel po polsku) i '1200.50' → '1200.50'. */
export function parseMoney(raw: string): string {
  const oczyszczone = (raw ?? "")
    .replace(/\s| /g, "")
    .replace(/[^\d,.-]/g, "")
    .replace(",", ".");
  if (!oczyszczone || oczyszczone === "-" || Number.isNaN(Number(oczyszczone))) return "";
  return oczyszczone;
}

export function formatMoney(value: string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const liczba = Number(value);
  if (Number.isNaN(liczba)) return String(value);
  return liczba.toLocaleString("pl-PL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Suma tekstów kwotowych w groszach — bez pośredniego pływaka.
 *
 *  Każdą wartość najpierw normalizujemy, bo sumujemy również to, co użytkownik
 *  ma właśnie w polu: „3 400,50" jest w tym momencie równie prawdziwe jak
 *  „3400.50". Bez normalizacji przecinek dawał zero i interfejs pokazywał
 *  pozycję jako rozdysponowaną, choć nie była.
 */
export function sumMoney(values: (string | null | undefined)[]): string {
  const grosze = values.reduce((acc, v) => {
    if (!v) return acc;
    const znormalizowana = String(v).trim().startsWith("-")
      ? `-${parseMoney(String(v).slice(1))}`
      : parseMoney(String(v));
    if (!znormalizowana || znormalizowana === "-") return acc;
    const [cala, ulamek = ""] = znormalizowana.split(".");
    const znak = cala.startsWith("-") ? -1 : 1;
    const setne = Number((ulamek + "00").slice(0, 2)) || 0;
    return acc + znak * (Math.abs(Number(cala) || 0) * 100 + setne);
  }, 0);
  const znak = grosze < 0 ? "-" : "";
  const abs = Math.abs(grosze);
  return `${znak}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, "0")}`;
}
